export default __webpack_public_path__ + "static/media/IMG_1518.33253a1a.jpg";